import React from "react";
import PropTypes from "prop-types";
import GenericNavList from "./GenericNavList";
import style from "../../../scss/components/MainNavigation";
// import logo from '../../../img/logo.jpeg';
import logo from "../../../img/logo.webp";
import enLangLogo from "../../../img/globe.svg";
import cnLangLogo from "../../../img/globe.svg";
import geLangLogo from "../../../img/globe.svg";
import esLangLogo from "../../../img/globe.svg";
import ImageBlock from "../ImageBlock";
import searchIcon from "../../../img/search.svg";
import closeIcon from "../../../img/close.svg";
import COUNTRY_LANGUAGES from "./CountryLanguagesMapping";


export default class DesktopNavigation extends React.Component {
  constructor(props) {
    console.log(props,"props+++Navigation");
    super(props);
    const currentLocale = window.location.pathname.split("/")[1] || "en";

  

    this.state = {
      searchOpen: false,
      searchFocus: false,
      menuOpen: false,
      langMenuOpen: false,
      searchClass: "",
      langBlog: false,
      currentLocale: currentLocale
    };
    this.searchInputRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSearchSubmenu = this.handleSearchSubmenu.bind(this);
    this.closeSearchSubmenu = this.closeSearchSubmenu.bind(this);
    this.toggleClose = this.toggleClose.bind(this);
  }

  static propTypes = {
    mainMenuItems: PropTypes.array,
    contact_page_en_url: PropTypes.string,
    contact_page_uk_url: PropTypes.string,
    contact_page_es_url: PropTypes.string,
    search_page_en_url: PropTypes.string,
    search_page_uk_url: PropTypes.string,
    search_page_es_url: PropTypes.string,
  };

  static defaultProps = {
    mainMenuItems: [],
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    let bstr = window.location.href;
    if (bstr.includes("/blog")) {
      this.setState({ langBlog: true }, () => {});
    }
    this.getUserCountry();

  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  

  getNativeLanguages = (countryName) => {
    const countryKey = Object.keys(COUNTRY_LANGUAGES).find(
      key => key === countryName.replace(/\s+/g, '')
    ) || 'Default';
  
    return COUNTRY_LANGUAGES[countryKey]?.nativeLanguages[0] || COUNTRY_LANGUAGES['Default'].nativeLanguages;

  };

  getUserCountry = async () => {
    console.log('[Language Detection] Starting...');
  
    try {
      // 1. First check for user's preferred language in localStorage
      const preferredLanguage = localStorage.getItem('preferredLanguage');
      const languageExpiry = localStorage.getItem('languageExpiry');
      
      // Check if preference exists and hasn't expired (30 days)
      if (preferredLanguage && languageExpiry && Date.now() < parseInt(languageExpiry)) {
        console.log(`[Language Detection] Using preferred language: ${preferredLanguage}`);
        
        // Check if the current URL matches the preferred language
        const currentPath = window.location.pathname;
        const currentLocale = currentPath.split('/')[1] || 'en';
        
        // If current locale doesn't match preferred language, redirect
        if (currentLocale !== preferredLanguage) {
          console.log(`[Language Detection] Redirecting from ${currentLocale} to preferred language: ${preferredLanguage}`);
          
          // Get the path without locale
          const pathWithoutLocale = currentPath.replace(/^\/[^\/]+/, '') || '/';
          const newUrl = `${window.location.origin}/${preferredLanguage}${pathWithoutLocale}`;
          
          console.log(`[Language Detection] Redirecting to: ${newUrl}`);
          window.location.href = newUrl;
          return; // Stop execution if redirecting
        }
        
        // Set current locale from preference
        this.setState({ 
          currentLocale: preferredLanguage,
          languageSource: 'localStorage' 
        });
        return; // Exit early - important to prevent geo-detection flow
      }
  
      // 2. If no valid preference, proceed with geo-detection
      console.log('[Language Detection] No valid preference, detecting via GeoIP...');
      const response = await fetch('https://get.geojs.io/v1/ip/country.json');
      const data = await response.json();
      const countryName = data.name;
      console.log(`[Language Detection] Detected country: ${countryName}`);
  
      // 3. Get native languages for the country
      const nativeLanguages = this.getNativeLanguages(countryName);
      console.log(`[Language Detection] Native languages:`, nativeLanguages);
  
      // 4. Language to URL mapping
      const LANGUAGE_URL_MAPPING = {
        'English': 'en',
        'English (American)': 'en',
        'English (British)': 'en-uk',
        'Spanish': 'es',
        'Japanese': 'ja',
        'Chinese (Simplified)': 'zh',
        'German': 'de',
      };
  
      // 5. Get primary language (safe array handling)
      const primaryLanguage = Array.isArray(nativeLanguages) 
        ? nativeLanguages[0] 
        : nativeLanguages;
      console.log(`[Language Detection] Primary language: ${primaryLanguage}`);
  
      // 6. Map to language code (default to English)
      let languageCode = LANGUAGE_URL_MAPPING[primaryLanguage] || 'en';
      console.log(`[Language Detection] Mapped to code: ${languageCode}`);
  
      // 7. Get current path info
      const currentPath = window.location.pathname;
      const currentLocale = currentPath.split('/')[1];
      
      // 8. Check if we need to redirect
      const validLocales = Object.values(LANGUAGE_URL_MAPPING);
      const needsRedirect = validLocales.includes(currentLocale) 
        ? currentLocale !== languageCode
        : true;
  
      console.log(`[Language Detection] Needs redirect? ${needsRedirect}`);
  
      if (needsRedirect) {
        const cleanPath = currentPath.replace(new RegExp(`^/(${validLocales.join('|')})`), '') || '/';
        const newUrl = `${window.location.origin}/${languageCode}${cleanPath}`;
        
        // Store this as the preferred language with 30-day expiry
        localStorage.setItem('preferredLanguage', languageCode);
        localStorage.setItem('languageExpiry', (Date.now() + 30*24*60*60*1000).toString());
        
        console.log(`[Language Detection] Redirecting to: ${newUrl}`);
        window.location.href = newUrl;
        return; // Stop execution if redirecting
      }
  
      // 9. Update state if no redirect happened
      this.setState({ 
        country: countryName,
        nativeLanguages: Array.isArray(nativeLanguages) ? nativeLanguages : [nativeLanguages],
        currentLocale: languageCode,
        languageSource: 'geoDetection'
      }, () => {
        console.log('[Language Detection] State updated:', {
          country: countryName,
          currentLocale: languageCode,
          source: 'geoDetection'
        });
      });
  
    } catch (error) {
      console.error('[Language Detection] Error:', error);
      
      // Fallback to English
      const fallbackLanguage = localStorage.getItem('preferredLanguage') || 'en';
      console.log(`[Language Detection] Falling back to: ${fallbackLanguage}`);
      
      this.setState({ 
        nativeLanguages: ['English'],
        currentLocale: fallbackLanguage,
        languageSource: 'fallback'
      });
    }
  };

  

  handleClickOutside(event) {
    if (this.node && !this.node.contains(event.target)) {
      this.showSearch(false);
    }
  }
  toggleMenu() {
    let isMenuOpen = this.state.menuOpen;
    this.setState({ menuOpen: !isMenuOpen });
  }
  showSearch(flag) {
    var self = this;
    this.setState({ searchOpen: flag }, () => {
      window.setTimeout(function () {
        self.searchInputRef.current.focus();
      }, 100);
    });
  }
  toggleSearch() {
    var self = this;
    let isSearchOpen = self.state.searchOpen;
    let isMobile = window.innerWidth <= 1049;

    if (isMobile) {
      if (isSearchOpen) {
        this.setState({ searchOpen: false, searchFocus: false });
      } else {
        this.performSearch();
      }
    } else {
      this.setState({ searchOpen: !isSearchOpen }, () => {
        if (this.state.searchOpen) {
          window.setTimeout(function () {
            self.searchInputRef.current.focus();
          }, 100);
        }
      });
    }
  }

  toggleClose() {
    var self = this;
    let isSearchOpen = self.state.searchOpen;
    this.setState({ searchOpen: !isSearchOpen, searchFocus: false }, () => {});
  }
  handleSearchSubmenu() {
    var self = this;
    this.setState({ searchFocus: true }, () => {});
  }

  closeSearchSubmenu() {
    var self = this;
    this.setState({ searchFocus: false }, () => {});
  }

  performSearch() {
    let str = window.location.href;
    let search_page_url = str.includes("/es/")
      ? this.props.search_page_es_url
      : str.includes("/en-uk/")
      ? this.props.search_page_uk_url
      : this.props.search_page_en_url;
    if (this.state.query)
      window.location = search_page_url + "?query=" + this.state.query;
  }
  handleSearchClick = () => {
    if (this.state.menuOpen) this.performSearch();
    else this.showSearch(true);
  };
  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.performSearch();
    }
  };
  getImageProp = () => {
    let img = {};
    img.url = logo;
    return img;
  };
  getEnLangImageProp = () => {
    let img = {};
    img.url = enLangLogo;
    return img;
  };
  getCnLangImageProp = () => {
    let img = {};
    img.url = cnLangLogo;
    return img;
  };
  getGerLangImageProp = () => {
    let img = {};
    img.url = geLangLogo;
    return img;
  };
  getSpnLangImageProp = () => {
    let img = {};
    img.url = esLangLogo;
    return img;
  };

  togglelangMenu_China() {
      location.href = "https://www.hunterlabcolor.cn/";
  }
  
  togglelangMenu_Germany() {
    location.href = "https://www.hunterlab.de";
  }
  togglelangMenuBackup(lang) {
    let str = window.location.href;
    if (str.includes("/es/")) {
      if (lang == "English") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/es/", "/en/");
      } else if (lang == "UK English") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/es/", "/en-uk/");
      }
    }
    if (str.includes("/en/")) {
      if (lang == "Español") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/en/", "/es/");
      } else if (lang == "UK English") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/en/", "/en-uk/");
      }
    }
    if (str.includes("/en-uk/")) {
      if (lang == "Español") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/en-uk/", "/es/");
      } else if (lang == "English") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/en-uk/", "/en/");
      }else if (lang == "Japanese") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/en-uk/", "/ja/");
      }
      
    }
  }

  togglelangMenu = (langLabel) => {
    const localeArray = this.props.locale;
    const reverseLocaleMap = Object.fromEntries(
      localeArray.map(([code, label]) => [label, code])
    );
    
    const newLocale = reverseLocaleMap[langLabel];
    
    // Store the selected language in localStorage with 30-day expiry
    localStorage.setItem('preferredLanguage', newLocale);
    localStorage.setItem('languageExpiry', (Date.now() + 30*24*60*60*1000).toString());
    
    const currentPath = window.location.pathname;
    const localeRegex = new RegExp(`^/(${localeArray.map(([code]) => code).join("|")})(/|$)`);
    const updatedPath = currentPath.replace(localeRegex, `/${newLocale}/`);
    
    window.location.href = `${window.location.origin}${updatedPath}`;
  }
  

  toggleMenuList() {
    let isLangMenuOpen = this.state.langMenuOpen;
    this.setState({ langMenuOpen: !isLangMenuOpen });
  }

  getCurrentLangImageProp() {
    return this.getLangImageProp(this.state.currentLocale);
  }

  getLangImageProp(langCode) {
    const flags = {
      'en': this.getEnLangImageProp(),
      'es': this.getSpnLangImageProp(),
      'ja': this.getJaLangImageProp(),
      'zh': this.getZhLangImageProp(),
      'de': this.getDeLangImageProp(),
      'en-uk': this.getEnLangImageProp()
    };
    return flags[langCode] || this.getEnLangImageProp();
  }

  getImageProp() {
    return { url: logo };
  }

  getEnLangImageProp() {
    return { url: enLangLogo };
  }

  getSpnLangImageProp() {
    return { url: esLangLogo };
  }

  getJaLangImageProp() {
    return { url: enLangLogo }; // Replace with actual Japanese flag
  }

  getZhLangImageProp() {
    return { url: cnLangLogo };
  }

  getDeLangImageProp() {
    return { url: geLangLogo };
  }

  render() {
    const { currentLocale } = this.state;
    const { locale, footer } = this.props;
    
    const contactUrl = `/${currentLocale}/${footer.get_quote_url || 'contact'}`;
    const homeUrl = `/${currentLocale}/`;
    const searchText = currentLocale === 'es' ? "Búsqueda HunterLab.com" : currentLocale === 'ja' ? "HunterLab.comを検索" : "Search HunterLab.com";

    return (
      <section className="navbar">
        <div className="navbar-inner">
          <div className="navbar-left">
            <a className="navbar-logo" href={homeUrl}>
              <ImageBlock
                style={{ width: "132px" }}
                title="HunterLab Logo"
                image={this.getImageProp()}
                addWrapper={false}
              />
            </a>
            
            <a href={contactUrl} className="mobilecontact btn btn-outline-contact">
              {footer.get_quote_text || 'Get Quote'}
            </a>

            {!this.state.langBlog && (
              <button
                className={`sm-menu-lang-view ${this.state.menuOpen ? 'close' : ''}`}
                onClick={() => this.toggleMenuList()}
              >
                <ImageBlock image={this.getCurrentLangImageProp()} addWrapper={false} />
                <div className={`sm-menu-lang-list ${this.state.langMenuOpen ? 'open' : 'close'}`}>
                  <ul>
                    {locale.map(([code, label]) => (
                      code !== currentLocale && (
                        <li className="menu-li-lang" key={code}>
                          <a href="#" onClick={(e) => {
                            e.preventDefault();
                            this.togglelangMenu(label);
                          }}>
                            <ImageBlock image={this.getLangImageProp(code)} addWrapper={false} />
                            <span className="lang-txt">{label}</span>
                          </a>
                        </li>
                      )
                    ))}
                  </ul>
                </div>
              </button>
            )}

            <button
              className={`toggle-btn ${this.state.menuOpen ? 'open' : ''}`}
              onClick={() => this.toggleMenu()}
            />
          </div>

          <nav
            className={`navbar-right ${this.state.menuOpen ? 'open' : ''} ${this.state.searchOpen ? 'active' : ''}`}
          >
            <GenericNavList
              prefix="navbar-nav"
              items={this.props.menus}
              showDesc={true}
            />

            <div className="navbar-right-right">
              <div className="nav-contact-menu">
                <li className="nav-btn">
                  <a
                    href={contactUrl}
                    className="btn btn-outline-contact desktopcontact get-quote-btn"
                  >
                    {footer.get_quote_text || 'Get Quote'}
                  </a>
                </li>
              </div>

              {!this.state.searchOpen && !this.state.langBlog && (
                <li className="has-menu menu-lang-selector">
                  <button>
                    <ImageBlock image={this.getCurrentLangImageProp()} addWrapper={false} />
                    <div className="sub-nav mega-menu">
                      <div className="mega-menu-right">
                        <ul className="menu">
                          {locale.map(([code, label]) => (
                            code !== currentLocale && (
                              <li className="menu-li-lang" key={code}>
                                <a href="#" onClick={(e) => {
                                  e.preventDefault();
                                  this.togglelangMenu(label);
                                }}>
                                  <ImageBlock image={this.getLangImageProp(code)} addWrapper={false} />
                                  <span className="lang-txt">{label}</span>
                                </a>
                              </li>
                            )
                          ))}
                        </ul>
                      </div>
                    </div>
                  </button>
                </li>
              )}

              <form className="nav-search-form" ref={(node) => (this.node = node)}>
                <div className="form-group has-icon">
                  <div className="icon-addon">
                    <input
                      ref={this.searchInputRef}
                      type="text"
                      className="form-control"
                      placeholder={searchText}
                      onChange={(e) => this.setState({ query: e.target.value })}
                      onKeyPress={this.handleKeyPress}
                      onFocus={this.handleSearchSubmenu}
                    />
                    {this.state.searchOpen && (
                      <img role="img" src={searchIcon} alt="Search" />
                    )}
                  </div>
                  {!this.state.searchOpen ? (
                    <a onClick={() => this.toggleSearch()} className="form-icon icon-search" />
                  ) : (
                    <img
                      className="form-icon"
                      style={{ width: "19px", top: "53%", right: "-8%" }}
                      onClick={() => this.toggleClose()}
                      role="img"
                      src={closeIcon}
                      alt="Close"
                    />
                  )}
                </div>
              </form>
            </div>
          </nav>
        </div>
      </section>
    );
  }
}